import React, { useEffect, useState } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { useUser } from "../Contexts/UserContext";
import CustomDatePicker from "./CustomDatePicker";
import ExportToExcelBTN from "./ExportToExcelBTN";
const API_URL = process.env.REACT_APP_DOMAIN_API_URL;
const ReportSelector = ({
  title,
  selectedData,
  setSelectedData,
  toDate,
  setToDate,
  fromDate,
  setFromDate,
  handleFetchReports,
}) => {
  const [list, setList] = useState({
    branchList: [{ BranchCode: 0, BranchName: "All" }],
    unitList: [{ UnitCode: 0, UnitName: "All" }],
  });
  const { user } = useUser();
  const { ClientId } = user;
  useEffect(() => {
    const fetchInitData = async () => {
      const res = await fetch(
        `${API_URL}/facility/get-client-all-unit/1/${ClientId}/0`
      ).then((res) => res.json());
      if (!res.success) {
        alert(res.message);
        return;
      }

      setList({
        branchList: [
          { BranchCode: 0, BranchName: "All" },
          ...res.data.branches,
        ],
        unitList: [{ UnitCode: 0, UnitName: "All" }, ...res.data.units],
      });
    };
    fetchInitData();
  }, []);
  const handleUnit = async (value) => {
    if (value.BranchCode === 0) {
      setList((prev) => ({
        ...prev,
        unitList: [{ UnitCode: 0, UnitName: "All" }],
      }));
      return;
    }
    const res = await fetch(
      `${API_URL}/facility/get-client-all-unit/2/${ClientId}/${value.BranchCode}`
    ).then((res) => res.json());
    if (!res.success) {
      alert(res.message);
      return;
    }
    setList((prev) => ({
      ...prev,
      unitList: [...res.data.units[0]],
    }));
  };
  const OnDataSelect = (key, value) => {
    if (value === null) return;
    if (key === "branchObj") {
      setSelectedData((prev) => ({ ...prev, unitObj: null }));
      handleUnit(value);
    }
    setSelectedData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Stack mt={1} mb={1} textAlign="start">
        <h2
          className="heading2"
          style={{
            fontSize: "14px",
            fontWeight: "500",
            padding: "0",
            lineHeight: "1px",
            margin: "0px 0px 0px 0vw",
            letterSpacing: "2px",
            textTransform: "uppercase",
            color: "#aaaaaa",
            fontFamily: "Poppins, sans-serif",
          }}
        >
          {title}
          <style>
            {`
      .heading2::after {
        content: "";
    width: 120px;
    height: 1px;
    display: inline-block;
    background: #D10101;
    margin: 4px 10px;
      }
    `}
          </style>
        </h2>
      </Stack>
      <Box
        sx={{
          p: 2,
          mb: 2,
          bgcolor: "background.default",
          boxShadow: 3,
          borderRadius: 2,
          border: "2px solid #D10101",
        }}
      >
        <Stack
          width="100%"
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Autocomplete
            size="small"
            options={list.branchList || []}
            getOptionLabel={(option) => option.BranchName}
            getOptionSelected={(option, value) =>
              option.BranchName === value.BranchName
            }
            renderInput={(params) => (
              <TextField {...params} label="Branch" size="small" />
            )}
            value={selectedData.branchObj}
            onChange={(e, value) => {
              OnDataSelect("branchObj", value);
            }}
            sx={{
              minWidth: "20%",
            }}
          />
          <Autocomplete
            size="small"
            options={list.unitList || []}
            getOptionLabel={(option) => {
              console.log("option", option);
              return option.UnitName;
            }} // Ensure that UnitName is returned
            getOptionSelected={(option, value) =>
              option.UnitCode === value.UnitCode
            }
            renderInput={(params) => (
              <TextField {...params} label="Unit" size="small" />
            )}
            value={selectedData.unitObj}
            onChange={(e, value) => {
              OnDataSelect("unitObj", value);
            }}
            sx={{
              minWidth: "20%",
            }}
          />

          <CustomDatePicker
            label={"From Date"}
            date={fromDate}
            setDate={setFromDate}
          />
          <CustomDatePicker
            label={"To Date"}
            date={toDate}
            setDate={setToDate}
          />
          <Button
            size="small"
            variant="contained"
            color="primary"
            onClick={() => handleFetchReports()}
            disabled={!selectedData.unitObj || !fromDate || !toDate}
            sx={{
              fontSize: "12px",
            }}
          >
            Show
          </Button>
        </Stack>
      </Box>
    </LocalizationProvider>
  );
};

export default ReportSelector;
